import type { GiftPassOrder } from '../../api/gift-passes';
import { formatMoney } from '../review/reviewQueueModel';

import { formatPassDateTime, orderSummary } from './gift-passes-model';

/** The only place money appears: a pass has no value of its own. */
export function GiftPassOrderRows({ order }: { order: GiftPassOrder }) {
  return (
    <>
      <dt>Order</dt>
      <dd>{orderSummary(order)}</dd>
      {order.serviceFeeCents > 0 && (
        <>
          <dt>Service fee</dt>
          <dd className="nb-tabular">{formatMoney(order.serviceFeeCents, order.currency)}</dd>
        </>
      )}
      <dt>Amount paid</dt>
      <dd className="nb-tabular" style={{ fontWeight: 700 }}>
        {formatMoney(order.amountPaidCents, order.currency)}
      </dd>
      <dt>Purchased</dt>
      <dd>{formatPassDateTime(order.purchasedAt)}</dd>
      <dt>Stripe payment</dt>
      <dd className="nb-mono" style={{ fontSize: 12 }}>
        {order.paymentIntentId}
      </dd>
    </>
  );
}
